import React from 'react';
import { Pagination } from 'antd';
import PropTypes from 'prop-types';
import MySelectV2 from 'components/Atoms/Select/v2';
import './styles.scss';
import { LeftOutlinedIcon, RightOutlinedIcon } from '../../Icon';
import { t } from 'utilities/lang';
import { FormattedMessage } from 'react-intl';

const ITEM_PER_PAGE = 10;
const OPTION_ITEM_PER_PAGE = [
  { name: t('pagination.results', { count: '05' }), id: 5 },
  { name: t('pagination.results', { count: '10' }), id: 10 },
  { name: t('pagination.results', { count: '20' }), id: 20 },
  { name: t('pagination.results', { count: '30' }), id: 30 },
  { name: t('pagination.results', { count: '40' }), id: 40 },
  { name: t('pagination.results', { count: '50' }), id: 50 },
];

const MyPaginationV2 = ({
  size,
  totalItem,
  pageSize,
  onChange,
  currentPage,
  options,
}) => {
  if (!totalItem || totalItem <= 0) return null;

  return (
    <div className="wrapper-paginate-v2 d-table w-100p">
      <div className="d-table-cell va-m">
        <span className="display-text">
          <FormattedMessage id="pagination.show" />
        </span>
        <div className="d-inline-block">
          <MySelectV2
            className="select-display"
            value={pageSize}
            options={options}
            placeholder=""
            onChange={(selected) => {
              const pageSize = parseInt(selected, 10);
              const payload = {
                skip: 0,
                current: 1,
                take: pageSize,
              };
              onChange(payload);
            }}
            allowClear={false}
          />
        </div>
        <span className="display-text pl-20">
          <FormattedMessage id="pagination.of_records" values={{ total: totalItem }} />
        </span>
      </div>

      <Pagination
        current={currentPage}
        size={size}
        total={totalItem}
        pageSize={pageSize}
        className="my-table-pagination-v2 py-16"
        showSizeChanger={false}
        onChange={(page) => {
          const payload = {
            skip: (page - 1) * pageSize,
            current: page,
            take: pageSize,
          };
          onChange(payload);
        }}
        itemRender={(page, type, originalElement) => {
          if (type === 'prev') {
            return (
              <span
                className="d-flex align-items-center mr-16"
                style={{ gap: 4 }}
              >
                <LeftOutlinedIcon /> <FormattedMessage id="pagination.prev" />
              </span>
            );
          }
          if (type === 'next') {
            return (
              <span
                className="d-flex align-items-center ml-16"
                style={{ gap: 4 }}
              >
                <FormattedMessage id="pagination.next" /> <RightOutlinedIcon />
              </span>
            );
          }
          return originalElement;
        }}
      />
    </div>
  );
};

MyPaginationV2.propTypes = {
  size: PropTypes.string,
  totalItem: PropTypes.number,
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
  currentPage: PropTypes.number,
  options: PropTypes.array,
};

MyPaginationV2.defaultProps = {
  size: 'small',
  totalItem: 0,
  currentPage: 1,
  pageSize: ITEM_PER_PAGE,
  onChange: () => null,
  options: OPTION_ITEM_PER_PAGE,
};

export default MyPaginationV2;
